<!-- eslint-disable prettier/prettier -->
<template>
  <div class="page">
    <div class="page-container">
      <div class="panel-info">
        <a-affix class="affix-title" :target="affixTarget">
          <div class="panel-info-title">
            <h2 :title="record.meetingTitle" class="text-ellipsis text-no-wrap overflow-hidden text-bold v-mr-sm">{{ record.meetingTitle }}</h2>
            <a-space class="v-ml-auto">
              <template v-if="record.meetingState != void 0 && record.meetingState != 2">
                <a-button class="v-px-sm" type="indigo" icon="form" @click="$router.push(`draft?id=${meetingId}&pid=${record.projectId}`)">编辑会议</a-button>
                <a-button class="v-px-sm" type="primary" icon="poweroff" @click="onCloseMeeting" v-if="record.meetingState == 1">会议结束</a-button>
                <a-button class="v-px-sm text-red" type="default" icon="delete" @click="onDelMeeting">删除会议</a-button>
              </template>
              <a-button class="v-px-sm" type="default" icon="rollback" @click="$router.go(-1)">返回</a-button>
            </a-space>
          </div>
        </a-affix>
        <a-divider />
        <div class="panel-info-section" style="margin-top: 0">
          <div class="panel-info-section-title"><span class="text-bold">会议基本信息</span></div>
          <table class="table table-plain">
            <tbody>
              <tr>
                <th width="160">会议主题</th>
                <template v-if="record.project">
                  <td width="38%">{{ record.meetingTitle }}</td>
                  <th width="160">项目名称</th>
                  <td>{{ record.project ? record.project.name : '' }}</td>
                </template>
                <template v-else>
                  <td colspan="3">{{ record.meetingTitle }}</td>
                </template>
              </tr>
              <tr>
                <th width="160">会议评审时间</th>
                <td width="38%">
                  {{ record.meetingStartTime }}
                  <template v-if="record.meetingStartTime">~ {{ record.meetingEndTime }}</template>
                </td>
                <th width="160">会议方式</th>
                <td>
                  {{ record.meetingType }}
                  <template v-if="record.meetingType == '视频会议'">（腾讯会议号：{{ record.meetingCode }}）</template>
                </td>
              </tr>
              <tr>
                <th>专家参会清单</th>
                <td colspan="3">
                  <a-tag color="red" v-for="item in record.experts" :key="item.userName">{{ item.realName }}</a-tag>
                  <a-button icon="mail" size="small" type="indigo" v-if="record.meetingState != 2" @click="onSmsMeeting">发送短信</a-button>
                </td>
              </tr>
              <tr>
                <th>美丽心灵参会人员</th>
                <td>
                  <a-tag class="v-my-xs" color="red" v-for="item in record.staffs" :key="item.id">{{ item.realName }}</a-tag>
                </td>
                <th>外部参会人员</th>
                <td>
                  <a-tag color="red" v-for="item in record.externalMembers" :key="item.memberName">{{ item.memberName }}</a-tag>
                </td>
              </tr>
              <tr>
                <th valign="top">会议备注</th>
                <td colspan="3">{{ record.meetingRemark }}</td>
              </tr>
              <tr>
                <th valign="top">会议文件</th>
                <td colspan="3">
                  <file-container :files="record.files" :belongId="meetingId" fileSign="PM" v-if="meetingId"></file-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="panel-info-section" v-if="record.votes && record.votes.length">
          <div class="panel-info-section-title flex items-center">
            <span class="text-bold">会议投票主题</span>
            <a-button class="v-ml-auto" type="indigo" icon="eye" size="small" @click="showDetail = true">查看投票明细</a-button>
          </div>
          <table class="table table-plain mt-space" v-for="(item, index) in record.votes" :key="index">
            <tbody>
              <tr>
                <th width="160">投票主题名称</th>
                <td width="38%">
                  <b class="text-indigo">{{ item.title }}</b>
                </td>
                <th width="160">投票类型</th>
                <td>
                  <template v-if="item.voteType == 0">同意/反对/弃权</template>
                  <template v-else-if="item.voteType == 1">动态配置投票选项</template>
                </td>
              </tr>
              <tr v-if="item.voteType == 0">
                <th valign="top">投票结果</th>
                <td colspan="3">
                  <span v-for="(option, index) in item.options" :key="option.optionId">
                    <template v-if="index > 0">，</template>
                    <b :class="{ 'text-red': option.content == '不同意', 'text-green': option.content == '同意' }">{{ item.results.filter(d => d.chooseOptionId == option.optionId).length }}</b>
                    {{ option.content }}
                  </span>
                  <span v-if="item.voteState == 2">，所有人已完成投票</span>
                  <span v-else>
                    ，
                    <b class="text-bold text-red">{{ record.experts.length - item.voted }}</b>
                    人未投票
                  </span>
                </td>
              </tr>
              <template v-else-if="item.voteType == 1">
                <tr>
                  <th valign="top">投票张数</th>
                  <td colspan="3">
                    每位专家最多可投
                    <b class="text-indigo">{{ item.maxNum }}</b>
                    张票
                  </td>
                </tr>
                <tr>
                  <th valign="top">投票结果</th>
                  <td colspan="3">
                    <div style="max-width: 600px">
                      <table class="table table-plain">
                        <tbody>
                          <tr>
                            <th class="text-left">投票选项</th>
                            <th width="100" class="text-center">投票结果</th>
                          </tr>
                          <tr v-for="option in item.options" :key="option.optionId">
                            <td>{{ option.content }}</td>
                            <td class="text-center">
                              已投
                              <b class="text-indigo">{{ item.results.filter(d => d.chooseOptionId == option.optionId).length }}</b>
                              票
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="v-mt-xs v-pa-xs v-px-sm bg-orange-1">
                        <span v-if="item.voteState == 2">所有人已完成投票</span>
                        <span v-else>
                          <b class="text-bold text-green">{{ item.voted }}</b>
                          人已投票，
                          <b class="text-bold text-red">{{ record.experts.length - item.voted }}</b>
                          人未投票
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="panel-info-section" v-if="record.meetingState == 1 || record.meetingState == 2">
          <div class="panel-info-section-title"><span class="text-bold">会议纪要材料</span></div>
          <table class="table table-plain">
            <tbody>
              <tr>
                <td width="160" class="text-right">会议记录材料</td>
                <td>
                  <div style="width: 400px" v-if="record.meetingState == 1">
                    <a-upload-dragger
                      :action="`${baseURL}/file/upload`"
                      :data="{
                        params: JSON.stringify({ fileBelongId: meetingId, projectId, fileType: 10, fileSign: 'PM' }),
                      }"
                      :show-upload-list="{
                        showPreviewIcon: true,
                        showRemoveIcon: true,
                        showDownloadIcon: true,
                      }"
                      :file-list="fileList"
                      :before-upload="beforeUploadFile"
                      @change="handleUploadChange"
                      @download="({ fileId, name }) => downloadFile({ fileId, belongId: projectId, fileSign: 'PM', fileName: name })"
                      accept=".pdf, .doc, .docx, .xls, .xlsx, .txt"
                      ref="fileList"
                    >
                      <div class="v-pa-xs">
                        <a-icon type="plus" />
                        <p class="font-xs">点击选择或拖拽文件至此区域(支持pdf,word,excel,txt)</p>
                      </div>
                    </a-upload-dragger>
                  </div>
                  <file-container :files="record.mfiles" :belongId="meetingId" fileSign="PM" v-if="record.meetingState == 2 && record.mfiles"></file-container>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center v-mt-sm" v-if="record.meetingState == 1">
            <a-space>
              <a-button icon="check" type="primary" @click="handleSaveMinutes">保存会议纪要材料</a-button>
            </a-space>
          </div>
        </div>
      </div>
    </div>
    <a-modal title="投票明细" :visible="showDetail" @cancel="showDetail = false" width="900px">
      <template slot="footer">
        <a-button type="default" @click="showDetail = false">关闭</a-button>
      </template>
      <a-card :bordered="true" :body-style="{ padding: 0 }" v-for="(vote, index) in record.votes" :key="vote.voteId" :class="{ 'v-mt-md': index > 0 }">
        <span slot="title">{{ vote.title }}</span>
        <a-table size="small" :bordered="false" :pagination="false" :data-source="vote.details" rowKey="voteResultId">
          <a-table-column title="#" data-index="index" :width="50" align="center">
            <template slot-scope="text, record, index">{{ index + 1 }}</template>
          </a-table-column>
          <a-table-column title="投票时间" data-index="updateTime" :width="132" align="center">
            <template slot-scope="text, record">{{ record.updateTime ? record.updateTime.substring(0, 16) : '' }}</template>
          </a-table-column>
          <a-table-column title="专家姓名" data-index="realName" :width="120" align="left">
            <template slot-scope="text, record">{{ record.voteUser }}</template>意见
          </a-table-column>
          <a-table-column title="投票结果" data-index="options" align="left">
            <template slot-scope="text, record">{{ record.options.join('、') }}</template>
          </a-table-column>
          <a-table-column title="投票意见" data-index="opinion" align="left" :width="300">
            <template slot-scope="text, record">
              <div class="lineh-13">{{ record.opinion }}</div>
            </template>
          </a-table-column>
        </a-table>
      </a-card>
    </a-modal>
  </div>
</template>

<script>
import { getMeeting, delMeeting, closeMeeting, saveMeetingMinutes, sendMeetingSms } from '@/api/project/meeting'

export default {
  name: 'MeetingView',
  data() {
    return {
      meetingId: undefined,
      projectId: undefined,
      loading: false,
      record: {},
      fileList: [],
      showDetail: false,
    }
  },
  methods: {
    init() {
      let { id, pid } = this.$route.query
      if (id) {
        this.meetingId = +id
        this.loadMeeting()
      }
      if (pid) {
        this.projectId = +pid
      }
    },
    loadMeeting() {
      this.loading = true
      getMeeting(this.meetingId)
        .then(({ data }) => {
          if (data.success) {
            let result = data.result
            let { experts, votes } = result
            let expertMap = experts.reduce((prev, cur) => ({ ...prev, [cur.userName]: cur.realName }), {})
            votes.forEach(vote => {
              let { options, results } = vote
              let optionMap = options.reduce((prev, cur) => ({ ...prev, [cur.optionId]: cur.content }), {})
              let resultMap = {}
              results.forEach(item => {
                let { voteResultId, voteUsername, chooseOptionId, updateTime } = item
                if (!resultMap[voteUsername]) {
                  resultMap[voteUsername] = {
                    voteResultId,
                    updateTime,
                    voteUsername,
                    voteUser: expertMap[voteUsername],
                    options: [],
                    opinion: item.opinion,
                  }
                }
                resultMap[voteUsername].options.push(optionMap[chooseOptionId])
              })
              vote.details = Object.values(resultMap)
            })
            this.record = result
            let { mfiles = [] } = data.result
            this.fileList = mfiles.map(file => ({
              uid: file.fileId,
              name: file.fileOriginName,
              status: 'done',
              fileSign: 'PM',
              ...file,
            }))
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleUploadChange(info) {
      this.fileList = this.handleUploadFile(info, -1)
    },
    handleSaveMinutes() {
      this.$message.destroy()
      let fileIds = this.fileList.map(file => file.fileId)
      if (fileIds.length == 0) {
        this.$message.warn('请上传会议纪要材料')
        this.$refs.fileList.$el.classList.add('uploader-empty')
        return
      }
      let params = {
        meetingId: this.meetingId,
        fileIds,
      }
      this.saving = true
      saveMeetingMinutes(params)
        .then(({ data }) => {
          this.saving = false
          if (data.success) {
            this.$message.success('操作成功')
            this.$router.go(-1)
          } else {
            this.$message.warn(data.msg)
          }
        })
        .catch(() => {
          this.$message.warn('操作失败')
        })
    },
    onSmsMeeting() {
      this.$confirm({
        title: '确认给专家发送会议短信？',
        onOk: () => {
          return new Promise((resolve, reject) => {
            sendMeetingSms(this.meetingId, this.record.projectId)
              .then(({ data }) => {
                if (data.success) {
                  this.$message.success('操作成功')
                  resolve()
                } else {
                  this.$message.warn(data.msg)
                  reject()
                }
              })
              .catch(() => {
                this.$message.error('操作失败')
              })
          })
        },
      })
    },
    onDelMeeting() {
      this.$confirm({
        title: '确认删除该会议？',
        onOk: () => {
          return new Promise((resolve, reject) => {
            delMeeting(this.meetingId)
              .then(({ data }) => {
                if (data.success) {
                  this.$message.success('操作成功')
                  resolve()
                  this.$router.go(-1)
                } else {
                  this.$message.warn(data.msg)
                  reject()
                }
              })
              .catch(() => {
                this.$message.error('操作失败')
              })
          })
        },
      })
    },
    onCloseMeeting() {
      this.$confirm({
        title: '确认结束该会议？',
        onOk: () => {
          return new Promise((resolve, reject) => {
            closeMeeting(this.meetingId)
              .then(({ data }) => {
                if (data.success) {
                  this.$message.success('操作成功')
                  resolve()
                  this.$router.go(-1)
                } else {
                  this.$message.warn(data.msg)
                  reject()
                }
              })
              .catch(() => {
                this.$message.error('操作失败')
              })
          })
        },
      })
    },
  },
  created() {
    this.init()
    // this.loadVoteResult()
  },
}
</script>
